import React, { useState } from "react";
import "./DrivingManagementView.css";
import "../../management/PremiumGrid.css";
import "../../maintenance/MaintenanceView.css"; // Reuse KPI & Drawer CSS
import { Vehicle } from "../../data/database";
import AutoLogModal from "./AutoLogModal";

interface DrivingManagementProps {
    vehicles: Vehicle[];
}

const MOCK_ROWS = [
    { id: '12가 1025', model: '봉고 III EV', depot: '동부산', driver: '흰이인', type: '출퇴근', status: '충전중', mileage: 78, idle: 124, co2: 100.7, date: '2026-03-13' },
    { id: '12가 1043', model: '봉고 III EV', depot: '마포', driver: '오세현', type: '출퇴근', status: '운행중', mileage: 45, idle: 103, co2: 76.0, date: '2026-03-13' },
    { id: '12가 1079', model: '봉고 III EV', depot: '마포', driver: '한이인', type: '출퇴근', status: '운행중', mileage: 71, idle: 43, co2: 149.1, date: '2026-03-12' },
    { id: '12가 1108', model: '봉고 III EV', depot: '동부산', driver: '윤준서', type: '업무용', status: '주정차중', mileage: 71, idle: 58, co2: 48.8, date: '2026-03-12' },
    { id: '12가 1111', model: '봉고 III EV', depot: '동부산', driver: '김민준', type: '출퇴근', status: '주정차중', mileage: 44, idle: 91, co2: 37.7, date: '2026-03-11' },
    { id: '55구 4321', model: '아이오닉 5', depot: '강남', driver: '이지훈', type: '업무용', status: '운행중', mileage: 120, idle: 15, co2: 210.5, date: '2026-03-11' },
    { id: '44서 9876', model: 'EV6', depot: '서초', driver: '박서연', type: '출퇴근', status: '충전중', mileage: 35, idle: 88, co2: 55.2, date: '2026-03-10' },
    { id: '12가 1112', model: '봉고 III EV', depot: '인천', driver: '이서준', type: '출퇴근', status: '운행중', mileage: 57, idle: 33, co2: 104.3, date: '2026-03-10' },
    { id: '33라 5678', model: '포터 II EV', depot: '강남', driver: '정민기', type: '업무용', status: '주정차중', mileage: 95, idle: 42, co2: 168.4, date: '2026-03-09' },
    { id: '12가 1113', model: '봉고 III EV', depot: '마포', driver: '한이안', type: '출퇴근', status: '운행중', mileage: 76, idle: 50, co2: 111.1, date: '2026-03-09' },
    { id: '77하 1111', model: '아이오닉 6', depot: '서초', driver: '김아름', type: '출퇴근', status: '운행중', mileage: 62, idle: 28, co2: 98.6, date: '2026-02-28' },
    { id: '88호 2222', model: '봉고 III EV', depot: '동부산', driver: '최재형', type: '업무용', status: '충전중', mileage: 84, idle: 110, co2: 142.3, date: '2026-02-27' },
].sort((a, b) => b.date.localeCompare(a.date));

export default function DrivingManagementView({ vehicles }: DrivingManagementProps) {
    // Mock Data States
    const [selectedMonth, setSelectedMonth] = useState("2026-03");
    const [searchQuery, setSearchQuery] = useState("");
    const [activeRange, setActiveRange] = useState("이달");

    // Modal and Selection States
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [isLogModalOpen, setIsLogModalOpen] = useState(false);

    // Drawer State
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const isDrawerOpen = Boolean(selectedRow);

    const ranges = ["전체", "최근 7일", "이달", "지난달"];

    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setSelectedIds(MOCK_ROWS.map(r => r.id));
        } else {
            setSelectedIds([]);
        }
    };

    const handleSelectOne = (id: string) => {
        setSelectedIds(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    };

    const handleOpenLogModal = () => {
        setIsLogModalOpen(true);
    };

    const selectedVehiclesData = MOCK_ROWS.filter(r => selectedIds.includes(r.id));

    return (
        <div className="vm-page">
            <div className="vm-page-header-wrapper" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
                <div className="soh-header-left">
                    <h2 className="soh-header-title">운행 현황 상세 조회</h2>
                    <div className="soh-header-sub">실시간 운행 상태와 OBD 통신 데이터를 기반으로 차량별 운행 요약을 제공합니다.</div>
                </div>

                <div className="global-date-filter" style={{ display: 'flex', alignItems: 'center', gap: '12px', background: '#ffffff', padding: '8px 16px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                    <span style={{ fontSize: '13px', fontWeight: 600, color: '#64748b' }}>조회 기간</span>
                    <input
                        type="month"
                        className="toolbar-month-input"
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: '15px', fontWeight: 700, color: '#0f172a', cursor: 'pointer' }}
                    />
                </div>
            </div>

            {/* KPI Section matching Maintenance style */}
            <div className="maintenance-kpi-bar" style={{ gap: '12px' }}>
                <div className="m-kpi-card" style={{ flex: 1 }}>
                    <div className="m-kpi-label">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                            <path d="M4 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"></path>
                            <line x1="2" y1="14" x2="22" y2="14"></line>
                        </svg>
                        운행 차량 / 전체
                    </div>
                    <div className="m-kpi-value" style={{ color: '#0f172a' }}>
                        214 <span className="m-kpi-sub" style={{ color: '#64748b' }}>/ 219 대</span>
                    </div>
                </div>

                <div className="m-kpi-card" style={{ flex: 1 }}>
                    <div className="m-kpi-label">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="12" y1="2" x2="12" y2="22"></line>
                            <line x1="8" y1="2" x2="8" y2="22"></line>
                            <line x1="16" y1="2" x2="16" y2="22"></line>
                        </svg>
                        월간 총 주행거리
                    </div>
                    <div className="m-kpi-value">
                        {selectedMonth === "2026-03" ? "13,228" : "11,450"} <span className="m-kpi-sub">km</span>
                    </div>
                </div>

                <div className="m-kpi-card" style={{ flex: 1, borderLeft: '4px solid #10b981' }}>
                    <div className="m-kpi-label">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M11 21c4.418 0 8-3.582 8-8 0-3.314-2.015-6.155-5-7.39V4a2 2 0 0 0-4 0v1.61C7.015 6.845 5 9.686 5 13c0 4.418 3.582 8 8 8z"></path>
                            <circle cx="11" cy="13" r="2"></circle>
                        </svg>
                        월간 탄소 감축량
                    </div>
                    <div className="m-kpi-value" style={{ color: '#047857' }}>
                        {selectedMonth === "2026-03" ? "18,233" : "15,800"} <span className="m-kpi-sub" style={{ color: '#34d399' }}>kg</span>
                    </div>
                </div>

                <div className="m-kpi-card" style={{ flex: 1 }}>
                    <div className="m-kpi-label">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                            <line x1="12" y1="9" x2="12" y2="13"></line>
                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                        </svg>
                        고장 예측 알람
                    </div>
                    <div className="m-kpi-value" style={{ color: '#0f172a' }}>
                        0 <span className="m-kpi-sub">건</span>
                    </div>
                </div>
            </div>

            {/* Integrated Toolbar matching Maintenance style */}
            <div className="driving-toolbar" style={{ marginTop: '32px', border: '1px solid #e2e8f0', borderBottom: 'none', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
                <div className="driving-toolbar-left" style={{ gap: '20px' }}>
                    <div className="driving-section-title">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                            <path d="M2 17l10 5 10-5"></path>
                            <path d="M2 12l10 5 10-5"></path>
                        </svg>
                        차량별 운행 상세
                        <button className="btn-refresh" title="새로고침">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="23 4 23 10 17 10"></polyline>
                                <polyline points="1 20 1 14 7 14"></polyline>
                                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                            </svg>
                        </button>
                    </div>

                    <div className="driving-tabs">
                        {ranges.map((range) => (
                            <button
                                key={range}
                                className={`driving-tab-btn ${activeRange === range ? 'active' : ''}`}
                                onClick={() => setActiveRange(range)}
                            >
                                {range}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="driving-toolbar-right">
                    <button className="driving-action-btn primary-outline" onClick={handleOpenLogModal}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                        이메일 전송
                    </button>
                    
                    <button className="driving-action-btn green-solid">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                        </svg>
                        내보내기
                    </button>

                    <div className="driving-search-wrapper">
                        <input
                            type="text"
                            placeholder="차량/운전자 검색"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="driving-search-input"
                        />
                        <svg className="driving-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                    </div>
                </div>
            </div>

            {/* Grid Area matching Maintenance style */}
            <div className="vm-main">
                <div className="soh-table-card">
                    <div className="soh-table-wrapper" style={{ overflowX: 'auto' }}>
                        <table className="premium-grid vehicle-grid" style={{ minWidth: '1000px' }}>
                            <thead>
                                <tr>
                                    <th className="w-chk">
                                        <input
                                            type="checkbox"
                                            checked={selectedIds.length === MOCK_ROWS.length && MOCK_ROWS.length > 0}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>운행 일자</th>
                                    <th className="text-left">차량 정보</th>
                                    <th>운전자</th>
                                    <th style={{ backgroundColor: '#f0f9ff' }}>운행 범주</th>
                                    <th style={{ textAlign: 'right' }}>주행거리 (km)</th>
                                    <th style={{ textAlign: 'right' }}>공회전 (분)</th>
                                    <th style={{ textAlign: 'right' }}>탄소감축 (kg)</th>
                                    <th style={{ textAlign: 'center' }}>상세</th>
                                </tr>
                            </thead>
                            <tbody>
                                {MOCK_ROWS.map((row) => {
                                    const isSelected = selectedRow?.id === row.id;
                                    return (
                                        <tr
                                            key={`${row.id}-${row.date}`}
                                            className={isSelected ? "soh-row-selected" : ""}
                                            onClick={() => setSelectedRow(row)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td className="w-chk" onClick={(e) => e.stopPropagation()}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds.includes(row.id)}
                                                    onChange={() => handleSelectOne(row.id)}
                                                />
                                            </td>
                                            <td style={{ color: '#64748b', fontSize: '13px' }}>{row.date}</td>
                                            <td className="text-left">
                                                <div className="grid-icon-text">

                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginLeft: '4px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                            <span style={{ color: '#0f172a', fontWeight: 600 }}>{row.id}</span>
                                                            <span style={{ fontSize: '11px', color: '#0284c7', backgroundColor: '#e0f2fe', padding: '1px 4px', borderRadius: '3px', fontWeight: 700 }}>{row.depot}</span>
                                                        </div>
                                                        <span style={{ color: '#64748b', fontSize: '12px' }}>{row.model}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="grid-icon-text">
                                                    <div className="grid-avatar gray" style={{ width: '22px', height: '22px', fontSize: '11px' }}>{row.driver.charAt(0)}</div>
                                                    <span style={{ fontWeight: 500 }}>{row.driver}</span>
                                                </div>
                                            </td>
                                            <td style={{ backgroundColor: '#f0f9ff', color: '#0369a1', fontWeight: 500 }}>{row.type}</td>
                                            <td style={{ textAlign: 'right', fontWeight: 600 }}>{row.mileage}</td>
                                            <td style={{ textAlign: 'right', color: '#64748b' }}>{row.idle}</td>
                                            <td style={{ textAlign: 'right', color: '#10b981', fontWeight: 600 }}>{row.co2}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <button className="vm-action-btn-ghost" style={{ padding: '4px' }} onClick={(e) => { e.stopPropagation(); setSelectedRow(row); }}>
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <circle cx="12" cy="12" r="1"></circle>
                                                        <circle cx="12" cy="5" r="1"></circle>
                                                        <circle cx="12" cy="19" r="1"></circle>
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="driving-pagination" style={{ padding: '16px 24px', borderTop: '1px solid #f1f5f9' }}>
                        <div className="page-info">
                            총 <span style={{ fontWeight: 700 }}>219</span>개의 데이터
                        </div>
                        <div className="page-arrows">
                            <span className="page-num active">1</span>
                            <span className="page-num">2</span>
                            <span className="page-num">3</span>
                            <span className="page-num">4</span>
                            <span className="page-num">5</span>
                            <span style={{ margin: '0 8px', color: '#cbd5e1' }}>...</span>
                            <span className="page-num">22</span>
                        </div>
                    </div>
                </div>
            </div>

            <AutoLogModal
                isOpen={isLogModalOpen}
                onClose={() => setIsLogModalOpen(false)}
                selectedVehicles={selectedVehiclesData}
            />

            {/* 우측 폼 패널 오버레이 (Drawer) */}
            <div className={`vm-backdrop ${isDrawerOpen ? "open" : ""}`} onClick={() => setSelectedRow(null)}></div>
            <aside className={`vm-form-container ${isDrawerOpen ? "open" : ""}`}>
                {selectedRow && (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', padding: '0 4px' }}>
                            <div>
                                <h3 className="vm-form-title" style={{ margin: 0 }}>운행 상세 데이터</h3>
                            </div>
                            <button
                                onClick={() => setSelectedRow(null)}
                                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#94a3b8' }}
                            >
                                &times;
                            </button>
                        </div>

                        <div className="vm-form-body" style={{ marginTop: '24px' }}>
                            <div className="m-drawer-section">
                                <div className="m-drawer-label">차량 및 운전자 정보</div>
                                <div className="grid-icon-text" style={{ marginTop: '12px' }}>
                                    <div className="grid-avatar" style={{ width: '40px', height: '40px', fontSize: '16px', background: '#f1f5f9', color: '#475569' }}>{selectedRow.driver.charAt(0)}</div>
                                    <div>
                                        <div className="m-drawer-value" style={{ fontSize: '16px' }}>{selectedRow.driver}</div>
                                        <div style={{ fontSize: '13px', color: '#64748b' }}>{selectedRow.id} · {selectedRow.model}</div>
                                    </div>
                                </div>
                                <div className="m-cost-row" style={{ marginTop: '16px' }}>
                                    <div className="m-cost-label">운행 일자</div>
                                    <div className="m-cost-val">{selectedRow.date}</div>
                                </div>
                                <div className="m-cost-row">
                                    <div className="m-cost-label">소속 지점</div>
                                    <div className="m-cost-val">{selectedRow.depot}</div>
                                </div>
                            </div>

                            <div className="m-drawer-section">
                                <div className="m-drawer-label" style={{ marginBottom: '12px' }}>성과 지표</div>
                                <div className="m-cost-row">
                                    <div className="m-cost-label">일일 주행거리</div>
                                    <div className="m-cost-val" style={{ fontWeight: 700 }}>{selectedRow.mileage} km</div>
                                </div>
                                <div className="m-cost-row">
                                    <div className="m-cost-label">공회전 비율</div>
                                    <div className="m-cost-val">{Math.round(selectedRow.idle / 60 * 100) / 10} %</div>
                                </div>
                                <div className="m-cost-row" style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #f1f5f9' }}>
                                    <div className="m-cost-label" style={{ color: '#059669', fontWeight: 600 }}>CO2 감축 기여</div>
                                    <div className="m-cost-val" style={{ fontSize: '20px', color: '#059669', fontWeight: 800 }}>{selectedRow.co2} <span style={{ fontSize: '12px', fontWeight: 500 }}>kg</span></div>
                                </div>
                            </div>

                            <div className="m-drawer-section" style={{ background: '#f0f9ff', borderColor: '#bae6fd' }}>
                                <div className="m-drawer-label" style={{ color: '#0369a1' }}>국세청 운행기록부</div>
                                <div style={{ marginTop: '12px' }}>
                                    <div style={{ fontSize: '13px', color: '#0c4a6e', lineHeight: 1.5 }}>
                                        본 차량은 <strong>{selectedRow.type}</strong> 목적으로 운행되었습니다.
                                        OBD 데이터를 바탕으로 세무 증빙용 기록부가 자동 생성되었습니다.
                                    </div>
                                    <button className="driving-action-btn primary-outline" style={{ width: '100%', marginTop: '16px', justifyContent: 'center', background: 'white' }}>
                                        기록부 PDF 다운로드
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </aside>
        </div>
    );
}
